import axios from "axios";

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      window.dispatchEvent(new Event("sessionExpired")); // Trigger popup globally
      // OR direct redirect:
      // sessionStorage.clear();
      // window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axios;